import { socket } from 'api-client/socket';
import type { BaseEvent, BrowserContext, ExceptionUnhandledBrowserEvent } from 'bc-clickstream';
import { ExceptionUnhandledBrowserRuntype } from 'bc-clickstream';
import { browserTracker } from 'bc-clickstream/browser';
import { isFeatureFlagEnabled } from '../featureFlags';
import { handleAiChatEvent } from './ai';

type BrowserEvent = BaseEvent & {
  context: BrowserContext;
};

let lastEUEvent: Nullable<ExceptionUnhandledBrowserEvent> = null;

const tracker = browserTracker((err, event) => {
  if (err) {
    // console.error(err, 'Error handling clickstream event');
    return;
  }

  const clickstreamEnabled = isFeatureFlagEnabled('CLICKSTREAM_OTHER_TRACKING_ENABLED');

  if (!clickstreamEnabled) return;

  // Exception Unhandled events run the risk of being sent many times in rapid
  // succession, so we only send the first one of a particular type to avoid
  // DOSing our own server
  if (ExceptionUnhandledBrowserRuntype.guard(event)) {
    const currentEventKey = `${event.url}_${event.name}_${event.message}`;
    const lastEventKey = `${lastEUEvent?.url}_${lastEUEvent?.name}_${lastEUEvent?.message}`;

    if (lastEventKey === currentEventKey) {
      return;
    }

    lastEUEvent = event;
  } else {
    lastEUEvent = null;
  }

  if (event) {
    event = handleAiChatEvent(event);
    if (event === null) {
      return;
    }
    const eventWithContext: BrowserEvent = {
      ...event,
      context: {
        locale: Intl.DateTimeFormat().resolvedOptions().locale,
        page: {
          path: window.location.pathname,
          referrer: document.referrer,
          search: window.location.search,
          title: document.title,
          url: window.location.href,
        },
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        userAgent: navigator.userAgent,
      },
    };

    socket.emit('clickstream-event', eventWithContext);
  }
});

export default tracker;
export { type BrowserEvent };
